import { toUserFacingApiError } from '../utils/userFacingError'
import { api } from './api'

export type Faq = { id: number; category: string | null; question: string; answer: string; sortOrder: number; isActive: boolean }
export type FaqInput = { category?: string | null; question: string; answer: string; isActive?: boolean }

export const FAQ_LIMITS = { category: 120, question: 500, answer: 5000 } as const

type Envelope<T> = { success?: boolean; message?: string; data?: T } | null

function data<T>(body: unknown, fallback: string): T {
  const b = body as Envelope<T>
  if (!b?.success || b.data === undefined) throw new Error(b?.message || fallback)
  return b.data
}

export async function fetchFaqs(): Promise<{ items: Faq[]; max: number }> {
  try {
    const res = await api.get('/storebusiness/faqs')
    return data(res.data, 'Failed to load questions')
  } catch (e) {
    throw toUserFacingApiError(e, 'Failed to load questions')
  }
}

export async function createFaq(input: FaqInput): Promise<Faq> {
  try {
    const res = await api.post('/storebusiness/faqs', input)
    return data(res.data, 'Failed to add question')
  } catch (e) {
    throw toUserFacingApiError(e, 'Failed to add question')
  }
}

export async function updateFaq(id: number, patch: Partial<FaqInput>): Promise<Faq> {
  try {
    const res = await api.patch(`/storebusiness/faqs/${id}`, patch)
    return data(res.data, 'Failed to save question')
  } catch (e) {
    throw toUserFacingApiError(e, 'Failed to save question')
  }
}

export async function deleteFaq(id: number): Promise<void> {
  try {
    await api.delete(`/storebusiness/faqs/${id}`)
  } catch (e) {
    throw toUserFacingApiError(e, 'Failed to delete question')
  }
}

export async function reorderFaqs(ids: number[]): Promise<Faq[]> {
  try {
    const res = await api.patch('/storebusiness/faqs/reorder', { ids })
    return data<{ items: Faq[] }>(res.data, 'Failed to reorder').items
  } catch (e) {
    throw toUserFacingApiError(e, 'Failed to reorder questions')
  }
}
